import React, { useContext } from "react";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { SnackbarContext } from "../../../provider/MyContexts";

// import { useSnackbar } from "../../hooks/useSnackbar";

export default function CustomSnackbar() {
  const { snackbarOpen, snackbarInfo, handleSnackbarClose } = useContext(SnackbarContext);
  return (
    <Snackbar
      open={snackbarOpen}
      autoHideDuration={snackbarInfo.duration || 3000}
      onClose={handleSnackbarClose}
      anchorOrigin={snackbarInfo.anchorOrigin}
    >
      <Alert
        onClose={(event) => handleSnackbarClose(event, "reason")}
        severity={snackbarInfo.severity}
        variant="filled"
        sx={{
          width: "100%",
          alignItems: "center",
          whiteSpace: "pre-line",
          // ...snackbarInfo.sx,
        }}
      >
        {snackbarInfo.message}
      </Alert>
    </Snackbar>
  );
}
